module.exports = __webpack_public_path__ + "img/pix.f5506ba4.svg";